// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  message: 'DEV'
};

// DEV
// export const SERVER_URL = 'https://www.xmsapproveit.com/HVregistrationAPIDev/api/';
// export const DOWNLOAD_URL = 'https://www.xmsapproveit.com/HvDownloadsDev/downloads/';
// export const VERSION_CNTRL = '1.0';

//Test
// export const SERVER_URL = 'https://www.xmsapproveit.com/HVregistrationAPIDev/api/';
// export const DOWNLOAD_URL = 'https://www.xmsapproveit.com/HVregistrationAPIDev/CROPDownloads/';
// export const PAYMENT_URL = 'https://apitest.authorize.net/xml/v1/request.api';
// export const VERSION_CNTRL = '1.0';

// PROD
// export const SERVER_URL = 'https://hinduvidyalayaregapi.hcclt.org/api/';
// export const DOWNLOAD_URL = 'https://hinduvidyalayaregapi.hcclt.org/hvdownloads/';
export const SERVER_URL = 'https://www.xtramilesoft.com/hvapiprod/api/';
export const DOWNLOAD_URL = 'https://www.xtramilesoft.com/hvapiprod/hvdownloads/';
export const PAYMENT_URL = 'https://api.authorize.net/xml/v1/request.api';
export const VERSION_CNTRL = '1.2';



/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
